<template>
  <div v-if="chatInfo.is_doing === 1" class="lf live_im_box">
    <div class="live_im_box_head">
      <span>
        <i class="iconfont icon-2"></i>公告
      </span>
    </div>
    <div class="live_im_box_container">
      <div v-for="(item, index) in messegItem" :key = "index">
        <!-- 观众进入提示的样式 -->
        <p v-if = "item.type === 'TIMGroupTipElem'" class="live_im_container_tip">
          <span>{{item.user_name}}</span> 进入房间
        </p>
        <!-- 普通聊天的样式 -->
        <p v-else>
          <u class="live_im_container_name">{{item.nick}} : </u>
          <i v-html="emojiFilter(item.payload.text)" class="live_im_container_text"></i>
        </p>
      </div>
    </div>
    <div class="live_im_box_foot">
      <div class="live_im_box_foot_fun">
        <el-popover
          placement="bottom"
          width="241"
          trigger="click">
          <emoji-view ref="EmotionB" @AppendInputValue="AppendMessageText"></emoji-view>
          <p class="lf my_icon_box live_im_box_con" slot="reference">
            <i class="my_icon biaoqing"></i><span class="my_icon_text"></span>
          </p>
        </el-popover>
      </div>
      <p v-if = "loginOnOff" class="live_im_box_foot_input">
        <el-input class="lf" type="textarea" placeholder="请输入内容" v-model="sendText" maxlength="30" show-word-limit></el-input>
        <el-button class="lf" type="primary" @click = "send">发送</el-button>
      </p>
      <p class="live_im_box_foot_input" v-else>
        <a @click="loginBtn()">登陆</a>
        后发送弹幕！
      </p>
    </div>
  </div>
  <div v-else class="lf live_im_box">
    <div v-if="chatInfo.is_live === 0" class="live_im_box_head">
      <span>
        <i class="iconfont icon-2"></i>公告
      </span>
      直播审核中，请您耐心等待～
    </div>
    <div v-if="chatInfo.is_doing === 0" class="live_im_box_head">
      <span>
        <i class="iconfont icon-2"></i>公告
      </span>
      直播尚未开始，请您稍后～
    </div>
    <div class="live_notice_im_box_container">
      <dl class="live_notice_im_box_time">
        <dt>直播时间</dt>
        <dd>{{chatInfo.start_time}}</dd>
      </dl>
      <dl v-if="chatInfo.is_doing === 0" class="live_notice_im_box_people">
        <dt>已报名</dt>
        <dd><span>{{chatInfo.sign_count}}</span> 人</dd>
      </dl>
      <dl v-if="chatInfo.is_live === 0" class="live_notice_im_box_people">
        <dt>直播申请审核中...</dt>
        <dd></dd>
      </dl>
      <div v-if="chatInfo.is_doing === 0" class="live_notice_im_box_btn">
         <el-button v-if="chatInfo.is_conllection === 0 && !signOnOff" @click = "signUp(chatInfo.list_id)">立即报名</el-button>
         <el-button v-if="chatInfo.is_conllection === 1  && !signOnOff" class="act" disabled>已报名</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import emoji from './emoji.vue'
export default {
  name: 'chatRoom',
  components: {
    emojiView: emoji
  },
  props: {
    chatInfo: {
      type: Object,
      required: true
    },
    userInfo: {
      type: Object,
      required: true
    },
    apiType: {}
  },
  data () {
    return {
      signOnOff: false,
      sendText: '',
      loginOnOff: false,
      groupId: '',
      messegItem: [],
      EmotionList: ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭',
        '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '可爱',
        '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问', '嘘',
        '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼',
        '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒',
        '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹',
        '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引',
        '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '挥手',
        '激动', '街舞', '献吻', '左太极', '右太极'],
      userInfoDialog: false // 用户弹窗显示
    }
  },
  async created () {
    const vueThat = this
    if (this.chatInfo.is_doing === 1) {
      vueThat.groupId = vueThat.chatInfo.av_chat_id // 获取群id
      try {
        const onMessageReceived = async function (event) {
          console.log(event)
          const data = event.data
          console.log(vueThat.chatInfo.av_chat_id)
          console.log(vueThat.groupId)
          for (let i = 0; i < data.length; i++) {
            if (data[i].type === vueThat.webIM.TYPES.MSG_TEXT) {
              const mesGroudid = data[i].conversationID.substring(5)
              if (data[i].conversationType === 'GROUP' && mesGroudid === vueThat.groupId) {
                vueThat.messegItem.push(data[i])
                data[i].baberrageType = 0
                await vueThat.$store.commit('live/save', data[i])
              }
            }
          }
        }
        vueThat.webIM.on(vueThat.webIM.EVENT.MESSAGE_RECEIVED, onMessageReceived)
        vueThat.webIM.login({ userID: this.$store.state.user.info.id + '', userSig: this.$store.state.user.info.sig })
          .then(function (imResponse) {
          }).catch(function (imError) {
          })
      } catch (e) {}
      vueThat.webIM.joinGroup({ groupID: vueThat.groupId, type: vueThat.webIM.TYPES.GRP_AVCHATROOM }).then(function (imResponse) {
      }).catch(function (imError) {})
      try {
        if (this.$store.state.user.info !== null) {
          this.loginOnOff = true
          if (this.$store.state.user.info.id === this.userInfo.user_id) {
            this.signOnOff = true
          } else {
            this.signOnOff = false
          }
        } else {
          this.loginOnOff = false
          this.signOnOff = false
        }
      } catch (e) {}
    }
    try {
      if (this.$store.state.user.info !== null) {
        if (this.$store.state.user.info.id === this.userInfo.user_id) {
          this.signOnOff = true
        } else {
          this.signOnOff = false
        }
      } else {
        this.signOnOff = false
      }
    } catch (e) {}
  },
  watch: {
    messegItem: {
      handler: function (val, oldVal) {
        this.$nextTick(function () { // 页面加载完成后执行
          const ele = document.getElementsByClassName('live_im_box_container')[0]
          ele.scrollTop = ele.scrollHeight
        })
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted () {
    // 绑定enter事件
    this.enterKeyup()
  },
  // 离开页面销毁事件
  destroyed () {
    // 销毁enter事件
    this.enterKeyupDestroyed()
  },
  methods: {
    // 校验表情
    emojiFilter (text) {
      const vueThat = this
      return text.replace(/\[([^\]]+)\]/g, (words) => {
        words = words.replace('[', '')
        words = words.replace(']', '')
        const index = vueThat.EmotionList.indexOf(words)
        if (index !== -1) {
          return `<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif" style="width: 20px; height: 20px;margin: 0 1px">`
        } else {
          return words
        }
      })
    },
    // 点击报名
    signUp: function (id) {
      const vueThat = this
      if (vueThat.$store.state.user.info === null) {
        vueThat.$alert('请您先登录账号！', '温馨提示', {
          showConfirmButton: true,
          iconClass: 'iconfont icon-jinggao',
          confirmButtonText: '去登录',
          callback: action => {
            vueThat.$router.push({ name: 'Login' })
          }
        })
      } else {
        vueThat.myApi.signUp({ type: 1, list_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$alert('报名成功', '温馨提示', {
              type: 'success',
              iconClass: 'iconfont icon-icon_richeng_btn_pass',
              confirmButtonText: '确定',
              showClose: false,
              callback: action => {
                vueThat.chatInfo.sign_count += 1
                vueThat.chatInfo.is_conllection = 1
              }
            })
          }
        })
      }
    },
    // 发送消息
    send: function () {
      const vueThat = this
      const text = vueThat.sendText
      const showMes = {
        nick: vueThat.$store.state.user.info.name,
        payload: {
          text: text
        },
        baberrageType: 1
      }
      vueThat.messegItem.push(showMes)
      vueThat.$store.commit('live/save', showMes)
      vueThat.sendText = ''
      vueThat.myApi.sensitive({ string: text, type: 'im' }).then(async (res) => {
        if (res.data.code === 200) {
          const messeg = vueThat.webIM.createTextMessage({
            to: vueThat.groupId,
            conversationType: vueThat.webIM.TYPES.CONV_GROUP,
            // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考 消息优先级与频率控制
            // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
            priority: vueThat.webIM.TYPES.MSG_PRIORITY_NORMAL,
            payload: {
              text: text
            }
          })
          // 2. 发送消息
          const promise = vueThat.webIM.sendMessage(messeg)
          promise.then(async function (res) {
            console.log(res)
            // 发送成功
            if (res.code === 0) {
            }
          }).catch(function (imError) {
            console.log(imError)
          })
        }
      }).catch(() => {})
    },
    // 表情选中后追加在消息后
    AppendMessageText (EmotionChinese) {
      this.sendText += EmotionChinese
    },
    // 登陆按钮
    loginBtn () {
      const url = window.location.href
      this.$store.commit('other/updateOldUrl', url)
      this.$router.push({ name: 'Login' })
    },
    // 监控回车键
    enterKey (event) {
      const componentName = this.$options.name
      if (componentName === 'chatRoom') {
        const code = event.keyCode
          ? event.keyCode
          : event.which
            ? event.which
            : event.charCode
        if (code === 13) {
          this.send()
        }
      }
    },
    // 消除回车键
    enterKeyupDestroyed () {
      document.removeEventListener('keyup', this.enterKey)
    },
    // 添加回车键
    enterKeyup () {
      document.addEventListener('keyup', this.enterKey)
    }
  }
}
</script>

<style>
</style>
